import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

const selectStore = (state: ApplicationState) =>
  state.GroupKeyMetricLinkerStore

export const selectGroupKeyMetricLinkerByKeyMetricId = createSelector(
  [selectStore],
  (store) => store.byKeyMetricId
)

export const selectGroupIdsForKeyMetric = createSelector(
  [
    selectStore,
    (_: ApplicationState, keyMetricId: string) => keyMetricId
  ],
  (store, keyMetricId) => store.byKeyMetricId[keyMetricId] || []
)

export const selectKeyMetricIdsForGroup = createSelector(
  [
    selectStore,
    (_: ApplicationState, groupId: string) => groupId
  ],
  (store, groupId) => store.byGroupId[groupId] || []
)
